/* ==========================================================
   SOL-AFRICA SMART SOLAR DESIGNER
   Version 1.1.0
   PART 1 OF X
==========================================================

DO NOT SAVE AFTER THIS PART.
WAIT UNTIL THE FINAL PART HAS BEEN SENT.
========================================================== */

const PANEL_WATTS = 715;
const SUN_HOURS = 4.5;
const PANEL_AREA = 2.8;

const appliances = [

{
    id: "fridge",
    name: "Refrigerator",
    watts: 150,
    hours: 8,
    quantity: 0,
    icon: "❄️"
},

{
    id: "tv",
    name: "Television",
    watts: 120,
    hours: 5,
    quantity: 0,
    icon: "📺"
},

{
    id: "washing",
    name: "Washing Machine",
    watts: 500,
    hours: 1,
    quantity: 0,
    icon: "🧺"
},

{
    id: "microwave",
    name: "Microwave",
    watts: 1200,
    hours: 0.25,
    quantity: 0,
    icon: "🍽️"
},

{
    id: "aircon",
    name: "Air Conditioner",
    watts: 1500,
    hours: 6,
    quantity: 0,
    icon: "❄️"
},

{
    id: "dishwasher",
    name: "Dishwasher",
    watts: 1800,
    hours: 1.5,
    quantity: 0,
    icon: "🍴"
},

{
    id: "geyser",
    name: "Geyser",
    watts: 3000,
    hours: 3,
    quantity: 0,
    icon: "🚿"
},

{
    id: "computer",
    name: "Computer",
    watts: 300,
    hours: 6,
    quantity: 0,
    icon: "💻"
},

{
    id: "led",
    name: "LED Lights",
    watts: 10,
    hours: 6,
    quantity: 0,
    icon: "💡"
},

{
    id: "incandescent",
    name: "Incandescent Lights",
    watts: 60,
    hours: 5,
    quantity: 0,
    icon: "💡"
},

{
    id: "oven",
    name: "Electric Oven",
    watts: 2400,
    hours: 1,
    quantity: 0,
    icon: "🔥"
},

{
    id: "stove",
    name: "Electric Stove",
    watts: 3000,
    hours: 1.5,
    quantity: 0,
    icon: "🍳"
},

{
    id: "airfryer",
    name: "Air Fryer",
    watts: 1700,
    hours: 0.5,
    quantity: 0,
    icon: "🍟"
},

{
    id: "pool",
    name: "Pool Pump",
    watts: 1100,
    hours: 8,
    quantity: 0,
    icon: "🏊"
},

{
    id: "kettle",
    name: "Kettle",
    watts: 2200,
    hours: 0.2,
    quantity: 0,
    icon: "☕"
},

{
    id: "ev",
    name: "EV Charger",
    watts: 7000,
    hours: 2,
    quantity: 0,
    icon: "🚗"
},

{
    id: "borehole",
    name: "Borehole Pump",
    watts: 1500,
    hours: 1,
    quantity: 0,
    icon: "💧"
}

];

function renderAppliances(){

    const container =
        document.getElementById("applianceContainer");

    if(!container){
        return;
    }

    container.innerHTML = "";

    appliances.forEach(appliance=>{

        container.insertAdjacentHTML(

            "beforeend",

            `
<div class="sa-appliance-card">

    <div class="sa-icon">
        ${appliance.icon}
    </div>

    <h3>
        ${appliance.name}
    </h3>

    <div class="sa-watts">
        ${appliance.watts} W
    </div>

    <div class="sa-counter">

        <button
            class="minus"
            data-id="${appliance.id}">

            −

        </button>

        <span>

            ${appliance.quantity}

        </span>

        <button
            class="plus"
            data-id="${appliance.id}">

            +

        </button>

    </div>

</div>
`
        );

    });

    registerButtons();

    updateSummary();

}function registerButtons(){

    document
        .querySelectorAll(".plus")
        .forEach(button=>{

            button.addEventListener("click",()=>{

                const appliance =
                    appliances.find(a=>a.id===button.dataset.id);

                if(appliance){

                    appliance.quantity++;

                    renderAppliances();

                }

            });

        });

    document
        .querySelectorAll(".minus")
        .forEach(button=>{

            button.addEventListener("click",()=>{

                const appliance =
                    appliances.find(a=>a.id===button.dataset.id);

                if(appliance && appliance.quantity>0){

                    appliance.quantity--;

                    renderAppliances();

                }

            });

        });

}

function calculateSystem(){

    let peakLoad = 0;

    let dailyEnergy = 0;

    appliances.forEach(appliance=>{

        peakLoad +=
            appliance.quantity *
            appliance.watts;

        dailyEnergy +=
            appliance.quantity *
            appliance.watts *
            appliance.hours;

    });

    dailyEnergy =
        dailyEnergy / 1000;

    const monthlyEnergy =
        dailyEnergy * 30;

    const requiredSolarKW =
        dailyEnergy / SUN_HOURS;

    const panelCount =
        Math.max(
            1,
            Math.ceil(
                requiredSolarKW /
                (PANEL_WATTS / 1000)
            )
        );

    const roofArea =
        (
            panelCount *
            PANEL_AREA
        ).toFixed(1);

    return{

        peakLoad,

        dailyEnergy,

        monthlyEnergy,

        panelCount,

        roofArea

    };

}

function recommendInverter(peakLoad){

    if(peakLoad<=3000){

        return "MUST 3kW Hybrid Inverter";

    }

    if(peakLoad<=5000){

        return "LuxPower SNA5000 5kW Hybrid Inverter";

    }

    if(peakLoad<=10000){

        return "Deye 10kW Hybrid Inverter";

    }

    if(peakLoad<=14000){

        return "LuxPower SNA14000 14kW Hybrid Inverter";

    }

    return "Deye 16kW Hybrid Inverter";

}

function recommendBattery(dailyEnergy){

    if(dailyEnergy<=6){

        return "LBSA 5.3kWh Wall Mount Battery";

    }

    if(dailyEnergy<=12){

        return "LBSA 10.6kWh Wall Mount Battery";

    }

    if(dailyEnergy<=20){

        return "Greenrich 10.24kWh Battery";

    }

    return "Dyness PowerBrick Battery";

}function updateSummary(){

    const system = calculateSystem();

    const peakElement =
        document.getElementById("peakLoad");

    const dailyElement =
        document.getElementById("dailyUsage");

    const monthlyElement =
        document.getElementById("monthlyUsage");

    const roofElement =
        document.getElementById("roofArea");

    if(peakElement){

        peakElement.innerHTML =
            system.peakLoad.toLocaleString() +
            " W";

    }

    if(dailyElement){

        dailyElement.innerHTML =
            system.dailyEnergy.toFixed(1) +
            " kWh";

    }

    if(monthlyElement){

        monthlyElement.innerHTML =
            system.monthlyEnergy.toFixed(0) +
            " kWh";

    }

    if(roofElement){

        roofElement.innerHTML =
            system.roofArea +
            " m²";

    }

    updateRecommendation(system);

}

function updateRecommendation(system){

    const recommendation =
        document.getElementById("recommendation");

    if(!recommendation){

        return;

    }

    const inverter =
        recommendInverter(system.peakLoad);

    const battery =
        recommendBattery(system.dailyEnergy);

    recommendation.innerHTML = `

<div class="sa-recommendation">

    <h3>
        Recommended System
    </h3>

    <div class="sa-rec-item">

        <strong>Hybrid Inverter</strong>

        <div>

            ${inverter}

        </div>

    </div>

    <div class="sa-rec-item">

        <strong>Battery</strong>

        <div>

            ${battery}

        </div>

    </div>

    <div class="sa-rec-item">

        <strong>Solar Panels</strong>

        <div>

            ${system.panelCount}
            × JA Solar ${PANEL_WATTS}W N-Type

        </div>

    </div>

    <div class="sa-rec-item">

        <strong>Estimated Roof Area</strong>

        <div>

            ${system.roofArea} m²

        </div>

    </div>

</div>

`;

}

function resetCalculator(){

    appliances.forEach(appliance=>{

        appliance.quantity = 0;

    });

    renderAppliances();

}document.addEventListener(

    "DOMContentLoaded",

    ()=>{

        renderAppliances();

    }

);

/* ==========================================================
   VERSION 1.1.0
   PREPARATION FOR VERSION 1.2

   The functions below will be expanded in the next version
   to pull product information directly from Shopify.
========================================================== */

const recommendationEngine = {

    inverter:null,

    battery:null,

    panels:0,

    roofArea:0,

    peakLoad:0,

    dailyEnergy:0,

    monthlyEnergy:0

};

function refreshRecommendationEngine(){

    const system = calculateSystem();

    recommendationEngine.peakLoad =
        system.peakLoad;

    recommendationEngine.dailyEnergy =
        system.dailyEnergy;

    recommendationEngine.monthlyEnergy =
        system.monthlyEnergy;

    recommendationEngine.panels =
        system.panelCount;

    recommendationEngine.roofArea =
        system.roofArea;

    recommendationEngine.inverter =
        recommendInverter(system.peakLoad);

    recommendationEngine.battery =
        recommendBattery(system.dailyEnergy);

}

function getRecommendationEngine(){

    refreshRecommendationEngine();

    return recommendationEngine;

}

/* ==========================================================
   FUTURE VERSION PLACEHOLDERS

   Version 1.2
   -------------
   Shopify Product Matching

   Version 1.3
   -------------
   Live Pricing

   Version 1.4
   -------------
   Installation Cost Calculator

   Version 1.5
   -------------
   Email PDF Proposal

========================================================== */
/* ==========================================================
   SOL-AFRICA SMART SOLAR DESIGNER
   Version 1.1.0

   END OF FILE
========================================================== */

/*
============================================================
VERSION HISTORY

v1.0.0
----------------------------------------
• Appliance List
• Quantity Controls
• Peak Load Calculation
• Daily Usage
• Monthly Usage

v1.1.0
----------------------------------------
• Recommendation Engine
• Inverter Recommendation
• Battery Recommendation
• Solar Panel Recommendation
• Roof Area Calculation

============================================================
*/

/*
============================================================
INITIALISE
============================================================
*/

refreshRecommendationEngine();

/*
============================================================
EXPOSE PUBLIC API

These functions are intentionally attached to window so
future Shopify sections, quote forms and product cards
can access the calculator without duplicating logic.

============================================================
*/

window.SolAfricaCalculator = {

    appliances,

    renderAppliances,

    calculateSystem,

    updateSummary,

    refreshRecommendationEngine,

    getRecommendationEngine,

    resetCalculator

};

/*
============================================================
END
============================================================
*/

/* ==========================================================
   QUOTE FORM INTEGRATION
   Launch Candidate 1
========================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const form = document.getElementById("solarQuoteForm");

    if (!form || !window.SolAfricaCalculator) {
        return;
    }

    form.addEventListener("submit", () => {

        const recommendation =
            window.SolAfricaCalculator.getRecommendationEngine();

        document.getElementById("quoteDailyUsage").value =
            recommendation.dailyEnergy.toFixed(1) + " kWh";

        document.getElementById("quoteMonthlyUsage").value =
            recommendation.monthlyEnergy.toFixed(0) + " kWh";

        document.getElementById("quotePeakLoad").value =
            recommendation.peakLoad + " W";

        document.getElementById("quoteRoofArea").value =
            recommendation.roofArea + " m²";

        document.getElementById("quoteInverter").value =
            recommendation.inverter;

        document.getElementById("quoteBattery").value =
            recommendation.battery;

        document.getElementById("quotePanels").value =
            recommendation.panels +
            " × JA Solar " +
            PANEL_WATTS +
            "W N-Type";

    });

});